module.exports = __webpack_public_path__ + "img/house-image-2.8e6490ce.jpg";